export default __webpack_public_path__ + "static/media/icasei-480x480.daf64f43.png";